import { z } from 'zod'

export const imageSchema = z.object({
  id: z.string(),
  url: z.string(),
  sortOrder: z.number().default(0),
})

export type ImageDto = z.infer<typeof imageSchema>

export const imageUploadResponseSchema = z.object({
  id: z.string().uuid(),
  url: z.string(),
})

export const avatarUploadResponseSchema = z.object({
  url: z.string(),
})

export const reorderImagesRequestSchema = z.object({
  imageIds: z.array(z.string().uuid()),
})

export const reorderImagesResponseSchema = z.object({
  success: z.boolean(),
})

export type ImageUploadResponse = z.infer<typeof imageUploadResponseSchema>
export type AvatarUploadResponse = z.infer<typeof avatarUploadResponseSchema>
export type ReorderImagesRequest = z.infer<typeof reorderImagesRequestSchema>
